import {
  buiAvatarColorize,
  type BuiAvatarProps,
  type TBuiAvatarColorize,
} from "@btnet/blueprint-components";

export type IBTAvatarProps = BuiAvatarProps;

export const btAvatarColorize = buiAvatarColorize;
export type TBTAvatarColorize = TBuiAvatarColorize;
